import React from "react";
import { Badge, colors } from "../design/badge";

interface InvitationStatusBadgeProps {
  status: string;
}

const InvitationStatusBadge: React.FC<InvitationStatusBadgeProps> = ({
  status,
}) => {
  let color;
  let title;

  switch (status) {
    case "pending":
      color = "blue";
      title = "Pending";
      break;
    case "accepted":
    case "confirmed":
      color = "green";
      title = "Confirmed";
      break;
    case "declined":
    case "denied":
      color = "red";
      title = "Declined";
      break;
    case "change_requested":
      color = "yellow";
      title = "Change Requested";
      break;
    default:
      color = "zinc";
      title = status ?? "Unknown";
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default InvitationStatusBadge;
